<template>
  <div class="ref-chart">
    <div
      class="ref-chart__toggle"
      :class="{ 'ref-chart__toggle--open': isOpen }"
      @click="isOpen = !isOpen"
    >
      <div class="ref-chart__toggle-left">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="ref-chart__icon">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12" />
        </svg>
        <span class="ref-chart__title">Training Days Reference Chart</span>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="ref-chart__arrow" :class="{ 'ref-chart__arrow--open': isOpen }">
        <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
      </svg>
    </div>
    <transition name="ref-slide">
      <div v-if="isOpen" class="ref-chart__body">
        <table class="ref-table">
          <thead>
            <tr>
              <th>Price (RM)</th>
              <th>Training Days</th>
              <th>Claim Per Day (RM)</th>
              <th>Viewing Hours</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key) in staticDatas" :key="key">
              <td>
                <span class="ref-badge ref-badge--green">RM {{ Number(item.price).toLocaleString() }}</span>
              </td>
              <td>
                <span class="ref-days">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="ref-days__icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                  </svg>
                  {{ item.trainingDays }} days
                </span>
              </td>
              <td>
                <span class="ref-badge ref-badge--blue">RM {{ claimPerDay(item) }}</span>
                <span class="ref-per-day">/ day</span>
              </td>
              <td>
                <span class="ref-hours">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="ref-hours__icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                  </svg>
                  {{ item.viewingHours }} hrs
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    datas: Array,
  },
  data: () => ({
    staticDatas: [],
    isOpen: false,
  }),
  created() {
    this.staticDatas = this.datas.reverse();
  },
  methods: {
    claimPerDay(item) {
      return `${(item.price / item.trainingDays).toFixed(2)}`;
    },
  },
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .ref-chart {
  background: var(--app-elevated);
}

.dark-mode .ref-chart__arrow {
  color: var(--app-text-faint);
}

.dark-mode .ref-chart__body {
  background: var(--app-card);
}

.dark-mode .ref-table thead th {
  color: var(--app-text-muted);
  border-bottom: 2px solid var(--app-border);
}

.dark-mode .ref-table tbody td {
  color: var(--app-text);
  border-bottom: 1px solid var(--app-border);
}

.dark-mode .ref-table tbody tr:hover td {
  background: var(--app-accent-soft);
}

.dark-mode .ref-badge--green {
  background: var(--app-success-bg);
}

.dark-mode .ref-badge--blue {
  background: var(--app-accent-soft);
}

.dark-mode .ref-per-day {
  color: var(--app-text-faint);
}

.dark-mode .ref-days,
.dark-mode .ref-hours {
  color: var(--app-text);
}

.dark-mode .ref-days__icon,
.dark-mode .ref-hours__icon {
  color: var(--app-text-faint);
}

/* >>> end auto-dark <<< */

.ref-chart {
  margin-bottom: 20px;
  border-radius: 14px;
  overflow: hidden;
  background: #eaecef;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

.ref-chart__toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  cursor: pointer;
  transition: background 0.15s ease;
  user-select: none;
}

.ref-chart__toggle:hover {
  background: #e2e5ea;
}

.ref-chart__toggle-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ref-chart__icon {
  width: 20px;
  height: 20px;
  color: #0ea5e9;
}

.ref-chart__title {
  font-size: 0.85rem;
  font-weight: 700;
  color: #3a3f47;
  letter-spacing: -0.1px;
}

.ref-chart__arrow {
  width: 18px;
  height: 18px;
  color: #94a3b8;
  transition: transform 0.25s ease;
}

.ref-chart__arrow--open {
  transform: rotate(180deg);
}

.ref-chart__body {
  background: #fff;
  padding: 16px 20px 20px;
  border-top: 1px solid #e2e5ea;
}

/* Table */
.ref-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.8rem;
  table-layout: fixed;
}

.ref-table thead th {
  text-align: left;
  font-size: 0.7rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 8px 14px;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
  width: 25%;
}

.ref-table tbody td {
  padding: 11px 14px;
  color: #334155;
  font-weight: 500;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

.ref-table tbody tr:last-child td {
  border-bottom: none;
}

.ref-table tbody tr {
  transition: background 0.12s ease;
}

.ref-table tbody tr:hover td {
  background: #f0f9ff;
}

/* Badges */
.ref-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
}

.ref-badge--green {
  background: #ecfdf5;
  color: #059669;
  border: 1px solid #a7f3d0;
}

.ref-badge--blue {
  background: #eff6ff;
  color: #2563eb;
  border: 1px solid #bfdbfe;
}

.ref-per-day {
  font-size: 0.72rem;
  color: #94a3b8;
  font-weight: 500;
  margin-left: 4px;
}

/* Days & Hours with icon */
.ref-days,
.ref-hours {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #334155;
}

.ref-days__icon,
.ref-hours__icon {
  width: 15px;
  height: 15px;
  color: #94a3b8;
  flex-shrink: 0;
}

/* Transition */
.ref-slide-enter-active,
.ref-slide-leave-active {
  transition: all 0.25s ease;
  max-height: 500px;
  overflow: hidden;
}

.ref-slide-enter,
.ref-slide-leave-to {
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0;
}

/* Dark mode */
.dark-mode .ref-chart {
  background: var(--app-page);
}

.dark-mode .ref-chart__toggle:hover {
  background: var(--app-card);
}

.dark-mode .ref-chart__title {
  color: var(--app-text);
}

.dark-mode .ref-chart__icon {
  color: var(--app-accent);
}

.dark-mode .ref-chart__body {
  background: var(--app-page);
  border-top-color: var(--app-border);
}

.dark-mode .ref-table thead th {
  color: var(--app-text-muted);
  border-bottom-color: var(--app-border);
}

.dark-mode .ref-table tbody td {
  color: var(--app-neutral-fg);
  border-bottom-color: var(--app-border);
}

.dark-mode .ref-table tbody tr:hover td {
  background: var(--app-card);
}

.dark-mode .ref-badge--green {
  background: var(--app-success-bg);
  color: var(--app-success-fg);
  border-color: var(--app-success-fg);
}

.dark-mode .ref-badge--blue {
  background: var(--app-accent-soft);
  color: var(--app-accent-strong);
  border-color: var(--app-accent-border);
}

.dark-mode .ref-per-day {
  color: var(--app-text-faint);
}

.dark-mode .ref-days,
.dark-mode .ref-hours {
  color: var(--app-neutral-fg);
}

.dark-mode .ref-days__icon,
.dark-mode .ref-hours__icon {
  color: var(--app-text-faint);
}

/* Responsive */
@media (max-width: 599px) {
  .ref-chart {
    border-radius: 12px;
    margin-bottom: 14px;
  }

  .ref-chart__toggle {
    padding: 12px 14px;
  }

  .ref-chart__title {
    font-size: 0.78rem;
  }

  .ref-chart__body {
    padding: 12px 14px 16px;
    overflow-x: auto;
  }

  .ref-table {
    min-width: 400px;
  }
}
</style>
